import { Box, Paper, Typography } from '@mui/material';

import { Loader } from 'common/components/Loader/Loader';
import { Column } from 'common/components/Table/CommonTableStyles';
import TableComponent from 'common/components/Table/Table';
import { dateInCorrectFormatWithFullYear } from 'common/utils/utilFunctions';

import useTableQuery from 'hooks/useTableQuery';

import {
	IAIShareTableprops,
	AIsharedResponse,
} from 'features/AiSimulation/api/type-def';

import styles from './AIShare.module.scss';

const AIShareTable = (props: IAIShareTableprops) => {
	const {
		rowData,
		isLoading,
		totalItems,
		handlePagination,
		navigateToSharedSimulation,
	} = props;

	const { tableQueryObj, updateTableQuery, updateQueryFlag } = useTableQuery({
		id: 'simulation_share_table',
	});

	const handlePageChange = (rowData: any, flag?: boolean) => {
		if (flag) {
			updateTableQuery(rowData);
			handlePagination(rowData);
		}
	};

	const navigateToDetail = (paramData: AIsharedResponse) => {
		updateQueryFlag(true);
		navigateToSharedSimulation(paramData);
	};

	const columnsList: readonly Column[] = [
		{
			id: 'name',
			label: 'Simulation Name',
			disablePadding: false,
			render: (params: any) => (
				<Typography
					component="div"
					data-testid="name-link"
					className={styles['ai-share-table-task-name']}
					onClick={() => navigateToDetail(params)}
				>
					{params?.simulationName}
				</Typography>
			),
		},
		{
			id: 'type',
			label: 'Type',
			disablePadding: false,
			render: (params: any) => (
				<Typography component="div" data-testid="taskname-link">
					{params?.type}
				</Typography>
			),
		},
		{
			id: 'sharedDate',
			label: 'Shared Date',
			disablePadding: false,
			render: (params: any) => (
				<Typography>
					<span>{dateInCorrectFormatWithFullYear(params.sharedDate)}</span>
				</Typography>
			),
		},
		{
			id: 'sharedBy',
			label: 'Shared By',
			disablePadding: false,
			render: (params: any) => (
				<Typography component="div" data-testid="taskname-link">
					{params?.sharedBy}
				</Typography>
			),
		},
	];

	return (
		<Box
			className={styles['ai-share-list-container']}
			data-testId="ai-share-table-section"
		>
			{rowData && rowData.length > 0 && !isLoading ? (
				<TableComponent
					defaultQuery={tableQueryObj}
					rows={rowData}
					columns={columnsList}
					defaultSortKey=""
					tableStyles={{ minWidth: 750, maxHeight: 440 }}
					totalItems={totalItems}
					onPageHandler={handlePageChange}
					isRenderPagination
				/>
			) : (
				<div>
					{!isLoading ? (
						<Paper className={styles['ai-share-table-loading-box']}>
							<Typography data-testid="no-data-found">No data found</Typography>
						</Paper>
					) : (
						<Paper>
							<Loader show={isLoading} />
						</Paper>
					)}
				</div>
			)}
		</Box>
	);
};
export default AIShareTable;
